import { createContext } from 'react';

const CertificateContext = createContext({});

export default CertificateContext;
